/**
 * German content bundle — mirrors en.js exactly.
 * Tone: premium, editorial, formal address ("Sie").
 */

const de = {
  code: 'de',
  htmlLang: 'de',
  ogLocale: 'de_DE',
  intlLocale: 'de-DE',
  label: 'Deutsch',
  shortLabel: 'DE',

  common: {
    bookConsultation: 'Beratung buchen',
    bookCall: 'Termin buchen',
    exploreServices: 'Leistungen entdecken',
    exploreTheServices: 'Leistungen ansehen',
    whatsapp: 'WhatsApp',
    whatsappLong: 'Per WhatsApp schreiben',
    learnMore: 'Mehr erfahren',
    viewAllServices: 'Alle Leistungen ansehen',
    inquireNow: 'Jetzt anfragen',
    email: 'E-Mail',
    placeholder: 'Platzhalter',
    or: 'oder',
    scroll: 'Scrollen',
    sending: 'Wird gesendet…',
    tryAgain: 'Erneut versuchen',
  },

  whatsappMessage:
    'Hallo Romilda, ich habe Ihre Website gefunden und würde gerne über meine Marke sprechen.',

  nav: {
    home: 'Start',
    services: 'Leistungen',
    about: 'Über mich',
    contact: 'Kontakt',
  },

  header: {
    openMenu: 'Menü öffnen',
    closeMenu: 'Menü schließen',
    primaryNavLabel: 'Hauptnavigation',
    mobileNavLabel: 'Mobile Navigation',
    languageGroupLabel: 'Sprache',
    switchTo: 'Zu Englisch wechseln',
  },

  footer: {
    tagline:
      'Eine Premium-Agentur für digitales Marketing – für Marken mit Anspruch. Content-Strategie, Social-Media-Wachstum und visuelle Identität, gestaltet mit redaktioneller Präzision und gemessen an Ergebnissen.',
    navigate: 'Navigation',
    servicesHeading: 'Leistungen',
    contactHeading: 'Kontakt',
    rights: 'Alle Rechte vorbehalten.',
    madeBy: 'Erstellt von',
    onInstagram: 'auf Instagram',
  },

  statsBand: {
    eyebrow: 'Die Zahlen',
  },

  stats: [
    {
      value: '500.000+',
      label: 'Views pro Monat',
      note: 'Über betreute Accounts und Kampagnen hinweg',
      testId: 'home-stats-views',
    },
    {
      value: '160.000+',
      label: 'Erreichte Accounts monatlich',
      note: 'Organische Reichweite, keine bezahlten Abkürzungen',
      testId: 'home-stats-reach',
    },
    {
      value: '100 %',
      label: 'Individuelle Strategien',
      note: 'Nie aus der Schublade, nie wiederverwertet',
      testId: 'home-stats-tailored',
    },
  ],

  marquee: [
    'Content-Strategie',
    'Social-Media-Wachstum',
    'Visuelle Identität',
    'Redaktionelle Bildsprache',
    'Markenpositionierung',
    'Digitalstrategie',
  ],

  services: [
    {
      slug: 'social-media-management',
      number: '01',
      icon: 'Sparkles',
      title: 'Social-Media-Management',
      short:
        'Strategische Account-Betreuung, organisches Wachstum und Engagement-Strategie – vollständig aus einer Hand.',
      overview:
        'Wir übernehmen die volle Verantwortung für Ihren Auftritt: Redaktionsplan, Texte, Community, Rhythmus. Jeder Beitrag steht mit Absicht dort, wo er steht – damit Ihr Account wächst statt nur zu bestehen.',
      who: [
        'Gründerinnen und Gründer, deren Kalender kein tägliches Posten mehr zulässt',
        'Marken mit starken Produkten und einem inkonsistenten Feed',
        'Teams, die den Rhythmus in verlässliche Hände geben möchten',
      ],
      outcomes: [
        'Ein konstanter Veröffentlichungsrhythmus, der Monat für Monat wirkt',
        'Organische Reichweite und Follower-Wachstum aus der richtigen Zielgruppe',
        'Engagement, das zu Anfragen führt – nicht nur zu Likes',
      ],
      includes: [
        'Monatlicher Redaktionsplan inklusive Planung und Veröffentlichung',
        'Captions und Copywriting in Ihrer Markenstimme',
        'Community-Management und Engagement-Strategie',
        'Hashtag-, Keyword- und Sichtbarkeitsstrategie',
        'Monatliches Performance-Reporting mit Einordnung',
      ],
    },
    {
      slug: 'content-strategy-aesthetic',
      number: '02',
      icon: 'LayoutTemplate',
      title: 'Content-Strategie & Ästhetik',
      short:
        'Hochwertige visuelle und textliche Ausrichtung – damit jeder Beitrag seinen Platz verdient.',
      overview:
        'Die meisten Marken haben kein Content-Problem, sondern ein Richtungsproblem. Wir definieren die Content-Säulen, die visuelle Sprache und die Erzählstrukturen, die Ihre Planung leicht und Ihren Feed unverkennbar machen.',
      who: [
        'Marken, deren Content veraltet, zerstreut oder markenfremd wirkt',
        'Unternehmen, die regelmäßig posten – ohne messbares Ergebnis',
        'Gründerinnen und Gründer, die Geschmack und Struktur gleichermaßen wollen',
      ],
      outcomes: [
        'Eine klare, eigenständige Content-Richtung, gegen die Sie briefen können',
        'Content-Säulen, die Planung schnell statt mühsam machen',
        'Ein Feed, der bewusst, redaktionell und hochwertig wirkt',
      ],
      includes: [
        'Framework für Content-Säulen',
        'Visuelle Ausrichtung und Moodboard',
        'Redaktionelle Foto- und Video-Art-Direction',
        'Frameworks für Hooks, Captions und Storytelling',
        'Ein 30-Tage-Content-Plan, sofort umsetzbar',
      ],
    },
    {
      slug: 'visual-identity-branding',
      number: '03',
      icon: 'Gem',
      title: 'Visuelle Identität & Branding',
      short:
        'Vollständige Markenentwicklung – Positionierung, Logo-Suite, Farbwelt und Guidelines.',
      overview:
        'Eine Identität ist kein Logo. Sie ist der Grund, warum jemand Sie für wertvoller hält, bevor Sie ein Wort gesagt haben. Wir bauen das gesamte System und geben Ihnen die Guidelines, um es zu schützen.',
      who: [
        'Neue Marken, die richtig starten wollen',
        'Etablierte Marken, die ihrem ursprünglichen Auftritt entwachsen sind',
        'Personal Brands auf dem Weg in eine hochwertigere Positionierung',
      ],
      outcomes: [
        'Eine geschlossene Identität, die Sie mit Stolz zeigen',
        'Sofortige Wiedererkennbarkeit an jedem Touchpoint',
        'Die visuelle Berechtigung für Premium-Preise',
      ],
      includes: [
        'Markenpositionierung und Messaging-Fundament',
        'Logo-Suite und Typografiesystem',
        'Farbpalette und Art Direction',
        'Brand-Guidelines-Dokument',
        'Social-Media-Brand-Kit und Vorlagen',
      ],
    },
    {
      slug: 'digital-strategy',
      number: '04',
      icon: 'LineChart',
      title: 'Digitalstrategie',
      short:
        'Datenbasierte Marketingpläne und Performance-Tracking – Entscheidungen auf Basis von Fakten.',
      overview:
        'Geschmack ohne Zahlen ist Dekoration. Wir kartieren Zielgruppe, Kanäle und Funnel und definieren die Kennzahlen, die Wachstum wirklich anzeigen – damit jedes Quartal eine Entscheidung ist und keine Vermutung.',
      who: [
        'Marken, die über Intuition und Improvisation hinaus skalieren wollen',
        'Teams, die unsicher sind, welche Kanäle Zeit und Budget verdienen',
        'Gründerinnen und Gründer, die eine dokumentierte Roadmap wollen',
      ],
      outcomes: [
        'Eine dokumentierte Wachstums-Roadmap mit klaren Prioritäten',
        'Klarheit darüber, welche Kanäle ihren Platz verdienen',
        'Entscheidungen auf Basis von Daten, die Sie wirklich lesen können',
      ],
      includes: [
        'Zielgruppen- und Wettbewerbsanalyse',
        'Kanal- und Funnel-Strategie',
        'Kampagnenplanung und Launch-Kalender',
        'KPI-Framework und Reporting-Dashboard',
        'Quartalsweise Strategie-Reviews',
      ],
    },
    {
      slug: 'websites-ai-automation',
      number: '05',
      icon: 'Cpu',
      title: 'Websites & AI-Automation',
      short:
        'Individuelle Websites, Web-Apps und KI-Automatisierungen – gebaut mit unserem Technologie-Partner CloudService.hr.',
      overview:
        'Sichtbarkeit ist die halbe Strecke. Irgendwann braucht eine Marke einen Ort, an dem aus Aufmerksamkeit eine Anfrage wird – und Systeme, die im Hintergrund weiterarbeiten, wenn Sie längst offline sind. Genau das entsteht in Partnerschaft mit CloudService.hr: individuelle Websites, Web- und Mobile-Apps, KI-Assistenten und Automatisierungen. Keine Templates, keine Baukästen.',
      who: [
        'Marken, die aus einem schönen Auftritt endlich verlässliche Anfragen machen wollen',
        'Unternehmen, die dieselben Abläufe jeden Tag von Hand erledigen',
        'Gründerinnen und Gründer mit einer Produktidee, die ein echtes MVP braucht',
      ],
      outcomes: [
        'Eine Website, die zu Ihrer Marke gehört – nicht zu einem Template',
        'KI und Automatisierung übernehmen Routine: Anfragen, Angebote, Nachfassen',
        'Ein Produkt, das live geht – in Wochen, nicht in Quartalen',
      ],
      includes: [
        'Individuelle Website, Landingpage oder Web-App',
        'KI-Assistenten, Advisor und Chat-Systeme',
        'Automatisierungen für Angebote, Leads und Follow-ups',
        'CRM- und Admin-Dashboards für Ihr Team',
        'iOS- und Android-Apps sowie SaaS-Plattformen',
        'Zahlungsflüsse, Hosting und Monitoring – produktionsreif',
      ],
    },
  ],

  /** value = kanonischer englischer Wert, der in der Datenbank gespeichert wird. */
  serviceOptions: [
    { value: 'Social Media Management', label: 'Social-Media-Management', group: 'marketing' },
    { value: 'Content Strategy & Aesthetic', label: 'Content-Strategie & Ästhetik', group: 'marketing' },
    { value: 'Visual Identity & Branding', label: 'Visuelle Identität & Branding', group: 'marketing' },
    { value: 'Digital Strategy', label: 'Digitalstrategie', group: 'marketing' },
    { value: 'Website', label: 'Website', group: 'tech' },
    { value: 'Web App', label: 'Web-App', group: 'tech' },
    { value: 'Mobile App', label: 'Mobile App (iOS / Android)', group: 'tech' },
    { value: 'AI Tool', label: 'KI-Tool / KI-Assistent', group: 'tech' },
    { value: 'Automation', label: 'Automatisierung', group: 'tech' },
    { value: 'CRM / Admin Dashboard', label: 'CRM / Admin-Dashboard', group: 'tech' },
    { value: 'SaaS Platform', label: 'SaaS-Plattform', group: 'tech' },
    { value: 'E-Commerce', label: 'Online-Shop / E-Commerce', group: 'tech' },
    { value: 'Not sure yet', label: 'Noch unentschlossen', group: 'other' },
  ],

  serviceOptionGroups: {
    marketing: 'Marketing & Marke',
    tech: 'Websites & AI-Automation',
    other: 'Sonstiges',
  },

  /** Diese Projektarten lösen die Budget- und Zeitrahmen-Felder aus. */
  techProjectValues: [
    'Website',
    'Web App',
    'Mobile App',
    'AI Tool',
    'Automation',
    'CRM / Admin Dashboard',
    'SaaS Platform',
    'E-Commerce',
  ],

  budgetOptions: [
    { value: 'Under EUR 3,000', label: 'unter 3.000 €' },
    { value: 'EUR 3,000 - 10,000', label: '3.000 – 10.000 €' },
    { value: 'EUR 10,000 - 25,000', label: '10.000 – 25.000 €' },
    { value: 'EUR 25,000+', label: '25.000 € +' },
    { value: 'Budget open', label: 'Noch offen' },
  ],

  timelineOptions: [
    { value: 'ASAP (within 2 weeks)', label: 'So schnell wie möglich (bis 2 Wochen)' },
    { value: 'Within 1 month', label: 'Innerhalb eines Monats' },
    { value: '1-3 months', label: '1 – 3 Monate' },
    { value: '3+ months', label: '3+ Monate' },
    { value: 'Timeline open', label: 'Noch offen – Beratung gewünscht' },
  ],

  partnership: {
    eyebrow: 'Technologie-Partnerschaft',
    title: 'Wenn die Marke steht, bauen wir das Produkt.',
    lede:
      'Für alles, was Code braucht, arbeite ich mit CloudService.hr – einem AI- und Automation-Studio aus Wien und Zagreb. Ich bringe Marke, Text und Ästhetik ein, das Studio die Technik. Für Sie bleibt eine Ansprechpartnerin: ich.',
    partnerLabel: 'Technologie-Partner',
    partnerName: 'CloudService.hr',
    partnerTagline: 'AI Solutions · SaaS Platforms · Mobile Apps · Business Automation',
    partnerClaim: 'Wir bauen digitale Produkte, nicht nur Webseiten.',
    partnerUrl: 'https://cloudservice.hr',
    visitPartner: 'CloudService.hr ansehen',
    capabilities: [
      {
        icon: 'BrainCircuit',
        title: 'AI Solutions',
        body: 'KI-Systeme, die echte Abläufe übernehmen – Advisor, Assistenten, Dokumentenerkennung.',
      },
      {
        icon: 'Boxes',
        title: 'SaaS-Plattformen',
        body: 'Vom Login bis zur Abrechnung: produktionsreife Plattformen statt Prototypen.',
      },
      {
        icon: 'Smartphone',
        title: 'Mobile Apps',
        body: 'iOS und Android, die sich wie Consumer-Apps anfühlen – nicht wie Firmen-Tools.',
      },
      {
        icon: 'Workflow',
        title: 'Business Automation',
        body: 'Interne Werkzeuge und Automatisierungen, die Ihrem Team Zeit zurückgeben.',
      },
    ],
    referencesLabel: 'Live im Einsatz',
    references: [
      {
        name: 'DealAlert.ai',
        url: 'https://dealalert.ai',
        tag: 'AI SaaS · Asset Intelligence',
        body: 'KI erkennt Auto- und Immobilienangebote unter Marktpreis – mit eigener iOS-App und Abrechnung über Stripe.',
      },
      {
        name: 'HausDesHandys.at',
        url: 'https://hausdeshandys.at',
        tag: 'Retail · AI Commerce',
        body: 'Ein lokaler Reparaturbetrieb, vollständig digitalisiert: Reparatur-Konfigurator, Smart Pricing, KI-Assistent und Admin-System.',
      },
      {
        name: 'NAAutomobile.at',
        url: 'https://naautomobile.at',
        tag: 'Automotive · Plattform',
        body: 'Premium-Autohaus-Plattform mit KI-Fotostudio, WhatsApp-first Anfragen, Finanzierung und Ankauf-Leads.',
      },
    ],
    note:
      'Vom ersten Gespräch zum fertigen Produkt: Idee verstehen, Konzept schärfen, MVP bauen, KI und Automatisierung integrieren, live gehen – und danach weiter verbessern.',
    cta: 'Projekt besprechen',
    liveLabel: 'Live ansehen',
  },

  valueProps: [
    {
      icon: 'Compass',
      title: 'Individuelle Strategie',
      body: 'Keine wiederverwerteten Präsentationen. Jede Strategie entsteht aus Ihrer Zielgruppe, Ihrem Markt und Ihrem Anspruch.',
    },
    {
      icon: 'Aperture',
      title: 'Ein redaktionelles Auge',
      body: 'Geschmack ist ein Geschäftsfaktor. Wir führen Ihre Marke so, wie ein Magazin seine Titelgeschichte führt.',
    },
    {
      icon: 'TrendingUp',
      title: 'Ergebnisorientierte Umsetzung',
      body: 'Schön ist die Grundlage. Wir messen Reichweite, Engagement und Anfragen – und handeln nach den Erkenntnissen.',
    },
    {
      icon: 'Layers',
      title: 'Markenaufbau statt Posten',
      body: 'Wir bauen wiedererkennbare Marken mit Haltung – keine Accounts, die einfach nur aktiv bleiben.',
    },
    {
      icon: 'Handshake',
      title: 'Wirklich persönlich',
      body: 'Sie arbeiten direkt mit Romilda. Kleine Kundenzahl, enge Betreuung, echte Verbindlichkeit.',
    },
  ],

  process: [
    {
      step: '01',
      title: 'Verstehen',
      body: 'Wir beginnen mit einem Gespräch: Ihre Zielgruppe, Ihr Markt, Ihre Positionierung und was Wachstum bisher gebremst hat.',
    },
    {
      step: '02',
      title: 'Strategie',
      body: 'Wir definieren Content-Säulen, visuelle Ausrichtung und Kanalplan – dokumentiert, damit nichts dem Zufall überlassen bleibt.',
    },
    {
      step: '03',
      title: 'Umsetzen',
      body: 'Wir produzieren und führen die Arbeit: Texte, Visuals, Kampagnen. Jedes Asset führt auf die Strategie zurück.',
    },
    {
      step: '04',
      title: 'Wachsen',
      body: 'Wir messen, verfeinern und skalieren, was funktioniert – mit klarem Reporting und Reviews, die wirklich weiterbringen.',
    },
  ],

  caseStudies: [
    {
      tag: 'Engagement-Wachstum',
      metric: '+ / –',
      title: 'Vom stillen Feed zum echten Dialog',
      body: 'Neuaufbau der Content-Säulen und ein Veröffentlichungsrhythmus, der eine Zielgruppe vom passiven Scrollen zum aktiven Austausch führt.',
      status: 'Case Study in Arbeit',
    },
    {
      tag: 'Reichweiten-Steigerung',
      metric: '+ / –',
      title: 'Organisch in den richtigen Räumen ankommen',
      body: 'Sichtbarkeits- und Formatstrategie mit Fokus auf qualifizierte Reichweite – die Accounts, die tatsächlich zu Anfragen werden.',
      status: 'Case Study in Arbeit',
    },
    {
      tag: 'Markenpositionierung',
      metric: '+ / –',
      title: 'Eine Neupositionierung, die den Preis erhöhte',
      body: 'Identität, Messaging und Art Direction neu aufgebaut, damit die Marke selbstbewusst ein höheres Segment besetzen konnte.',
      status: 'Case Study in Arbeit',
    },
    {
      tag: 'Visuelle Transformation',
      metric: 'Vorher / Nachher',
      title: 'Ein Feed wie eine Magazin-Doppelseite',
      body: 'Eine vollständige visuelle Überarbeitung: Farbwelt, Komposition und Grid-Rhythmus als eine durchgehende redaktionelle Erzählung.',
      status: 'Case Study in Arbeit',
    },
  ],

  testimonials: [
    {
      quote:
        'Romilda hat unseren Content nicht einfach schöner gemacht – sie hat uns eine Haltung gegeben. Zum ersten Mal fühlt sich unsere Marke so an, wie es unser Preis verlangt.',
      name: 'Kundenname',
      role: 'Gründerin, Markenkategorie',
      placeholder: true,
    },
    {
      quote:
        'Die Strategie war konkret, dokumentiert und wirklich unsere. Innerhalb von Wochen stieg unsere Reichweite – und vor allem fragten die richtigen Menschen an.',
      name: 'Kundenname',
      role: 'Marketingleitung, Markenkategorie',
      placeholder: true,
    },
    {
      quote:
        'Mit ihr zu arbeiten fühlt sich an, als hätte man Creative Director und Strategin in einem Gespräch. Nichts bleibt Vermutung, nichts sieht zufällig aus.',
      name: 'Kundenname',
      role: 'Inhaberin, Markenkategorie',
      placeholder: true,
    },
    {
      quote:
        'Sie hat ein redaktionelles Auge, das man nicht lernen kann – gepaart mit einem klaren Kopf für Zahlen. Diese Kombination ist selten und zeigt sich in den Ergebnissen.',
      name: 'Kundenname',
      role: 'Co-Founder, Markenkategorie',
      placeholder: true,
    },
    {
      quote:
        'Wir haben einen inkonsistenten Account übergeben und eine Marke zurückbekommen. Allein das Reporting hat verändert, wie wir intern entscheiden.',
      name: 'Kundenname',
      role: 'Geschäftsführung, Markenkategorie',
      placeholder: true,
    },
  ],

  photo: {
    homeHeroAlt:
      'Romilda, Gründerin von Romilda Marketing Hub, aufgenommen in einem redaktionellen Studio-Setting',
    homeHeroCaption: 'Romilda · Gründerin & Strategin',
    homeAboutAlt: 'Porträt von Romilda',
    homeAboutCaption: 'Gründerin · Strategin · Redaktionelles Auge',
    homeEditorialAlt:
      'Redaktionelles Porträt von Romilda in einem Studio mit geometrischem Licht',
    homeEditorialCaption: 'Redaktionelle Bildsprache',
    servicesHeroAlt: 'Romilda in einem Studio mit geometrischem Schattenwurf',
    servicesHeroCaption: 'Strategie · Content · Identität · Wachstum',
    aboutHeroAlt: 'Romilda Bahollari, Gründerin von Romilda Marketing Hub',
    aboutHeroCaption: 'Romilda · Gründerin',
    aboutPortraitAlt: 'Porträt von Romilda in weißer Bluse',
    aboutApproachAlt: 'Redaktionelles Porträt von Romilda vor einer Studiowand',
    aboutApproachCaption: 'Strategie trifft Art Direction',
    contactHeroAlt: 'Romilda, Gründerin von Romilda Marketing Hub',
    contactHeroCaption: 'Sie sprechen direkt mit Romilda',
  },

  home: {
    hero: {
      eyebrow: 'Premium-Studio für digitales Marketing',
      titleBefore: 'Strategie, die Ihre Marke ',
      titleAccent: 'unübersehbar',
      titleAfter: ' macht.',
      lede:
        'Premium-Content-Strategie, Social-Media-Wachstum und Branding für moderne Unternehmen, die ihren Auftritt auf ein neues Niveau bringen wollen – mit redaktionellem Auge gestaltet und an Ergebnissen gemessen.',
      statViews: 'Views pro Monat',
      statReach: 'erreichte Accounts',
      nowOffering: 'Neu im Angebot',
      aiTeaser: 'Romilda AI — Strategie-Impulse in Sekunden',
    },
    services: {
      eyebrow: 'Was wir tun',
      title: 'Fünf Disziplinen, eine geschlossene Marke.',
      lede:
        'Jedes Projekt entsteht rund um Ihre Positionierung – nicht rund um ein Paket. Wählen Sie die Disziplin, die Sie brauchen, oder lassen Sie uns das gesamte System bauen.',
    },
    about: {
      eyebrow: 'Romilda kennenlernen',
      title: 'Marketing auf Basis von Strategie – vollendet mit Geschmack.',
      p1: 'Ich habe Romilda Marketing Hub gegründet, weil ich immer die gleiche Lücke gesehen habe: Agenturen, die Zahlen berichten konnten, aber kein Auge hatten – und Kreative mit wunderschöner Arbeit ohne Strategie dahinter. Marken mussten sich entscheiden.',
      p2: 'Meine Arbeit liegt genau dazwischen. Ich plane wie eine Strategin – Zielgruppe, Positionierung, Funnels, Daten – und führe wie eine Redakteurin, die jeden Feed als Publikation mit Haltung behandelt. Das Ergebnis ist eine Marke, die durchdacht aussieht und arbeitet, als wäre sie konstruiert.',
      quote:
        'Geschmack ist keine Dekoration. Er ist der schnellste Weg zu signalisieren, dass Sie mehr wert sind.',
      readStory: 'Die ganze Geschichte lesen',
    },
    why: {
      eyebrow: 'Warum mit uns arbeiten',
      title: 'Der Unterschied liegt im Denken, nicht in der Vorlage.',
      lede:
        'Wenige Kundinnen und Kunden, enge Betreuung und ein Standard, den wir nicht senken.',
      aiTag: 'Neu',
      aiTitle: 'Romilda AI',
      aiBody:
        'Fragen Sie unsere hauseigene Strategie-Assistenz nach einer sofortigen Einschätzung zu Content, Branding oder Wachstum – noch bevor Sie ein Gespräch buchen.',
      aiHint: 'Widget unten rechts öffnen',
    },
    results: {
      eyebrow: 'Ergebnisse',
      title: 'Wachstum, das sich zeigen lässt.',
      lede:
        'Die vollständigen Case Studies werden gerade dokumentiert. Hier sehen Sie die Form der Arbeit – jede Karte wird durch echte Kundenzahlen und Vorher-Nachher-Visuals ersetzt.',
      sideNote:
        'Jedes Ergebnis beginnt gleich – mit einer dokumentierten Strategie und einer Art Direction, die sie unverkennbar macht.',
    },
    testimonials: {
      eyebrow: 'Vertrauen',
      title: 'Was Kundinnen und Kunden sagen.',
      lede:
        'Unten Platzhalter-Zitate – im erwarteten Ton geschrieben und bereit, durch echte Kundenstimmen ersetzt zu werden.',
    },
    process: {
      eyebrow: 'Der Prozess',
      title: 'So arbeiten wir zusammen.',
      lede:
        'Vier klar definierte Phasen, damit Sie jederzeit wissen, was als Nächstes passiert.',
    },
    bottom: {
      prefix: 'Erst einmal in Ruhe lesen?',
      servicesLink: 'Leistungen ansehen',
      aboutLink: 'Romildas Geschichte lesen',
    },
  },

  servicesPage: {
    hero: {
      eyebrow: 'Leistungen',
      titleLines: ['Fünf Disziplinen.', 'Eine Marke auf Niveau.'],
      lede:
        'Nehmen Sie eine Disziplin oder das gesamte System. In beiden Fällen ist die Strategie dokumentiert, die Art Direction bewusst und die Ergebnisse gemessen – nie geraten.',
      indexNavLabel: 'Leistungsübersicht',
    },
    stage: {
      scrollCue: 'Scrollen zum Entdecken',
      progressAria: 'Fortschritt der Leistungen',
      goTo: 'Zu {title}',
    },
    whoLabel: 'Für wen',
    outcomesLabel: 'Erwartete Ergebnisse',
    includesLabel: 'Was enthalten ist',
    process: {
      eyebrow: 'Der Prozess',
      title: 'So sieht die Zusammenarbeit aus.',
      lede:
        'Ganz gleich, welche Leistung Sie wählen – der Weg bleibt derselbe: klar, dokumentiert und gemeinsam.',
    },
    finalCta: {
      eyebrow: 'Nächster Schritt',
      title: 'Unsicher, welche Leistung Sie brauchen?',
      body:
        'Buchen Sie eine Beratung, und wir kartieren es gemeinsam – oder fragen Sie Romilda AI nach einer sofortigen Einschätzung, bevor Sie sich für ein Gespräch entscheiden.',
    },
  },

  aboutPage: {
    hero: {
      eyebrow: 'Über mich',
      titleLines: ['Ich baue Marken, die so', 'durchdacht aussehen, wie sie sind.'],
      lede:
        'Ich bin Romilda – Gründerin von Romilda Marketing Hub, einem Studio für Marken, die Strategie und Geschmack im selben Raum wollen. Meine Arbeit verbindet strukturiertes Marketingdenken mit redaktioneller Art Direction auf Modeniveau.',
    },
    story: {
      eyebrow: 'Die Geschichte',
      title: 'Wie das Studio entstanden ist.',
      p1: 'Ich habe im Marketing so angefangen wie viele – mit Tabellen, Reports und Kampagnenkalendern. Ich habe schnell gelernt, dass ich Zahlen wachsen lassen kann. Frustriert hat mich, Marken mit echtem Potenzial dabei zuzusehen, wie sie sich so präsentieren, dass sie ihren eigenen Wert untergraben.',
      p2: 'Gleichzeitig zog mich die Mode- und Redaktionsarbeit an – die Art, wie ein Magazin auf einer einzigen Doppelseite eine ganze Weltsicht vermitteln kann. Es wurde offensichtlich, dass beide Disziplinen zusammengehören: die Strenge der Strategie und die Selbstsicherheit guter Art Direction.',
      p3: 'Romilda Marketing Hub existiert, um beides zu halten. Wir planen sauber, wir sehen außergewöhnlich aus, und wir halten beides gegenseitig verantwortlich. Heute erreicht die Arbeit weit über hunderttausend Accounts im Monat – nicht durch Abkürzungen, sondern durch Konsequenz und einen sehr hohen Anspruch an alles, was hinausgeht.',
      quote:
        'Ich möchte nicht, dass Ihre Marke aussieht wie alle anderen, nur ein bisschen besser. Ich möchte, dass sie aussieht wie keine andere – und genau deshalb funktioniert.',
      cite: 'Romilda, Gründerin',
      numbersLabel: 'In Zahlen',
    },
    philosophy: {
      eyebrow: 'Philosophie',
      title: 'Vier Überzeugungen, die jedes Projekt prägen.',
      items: [
        {
          title: 'Immer zuerst die Strategie',
          body: 'Bevor ein einziges Asset entsteht, klären wir, mit wem wir sprechen, was diese Menschen glauben sollen und woran wir Erfolg erkennen. Kreation ohne dieses Fundament ist teure Dekoration.',
        },
        {
          title: 'Ästhetik ist kommerziell',
          body: 'Wie eine Marke aussieht, bestimmt, was sie verlangen kann. Wir behandeln Art Direction als Umsatzhebel, nicht als letzten Feinschliff – und halten sie auf redaktionellem Niveau.',
        },
        {
          title: 'Konsequenz schlägt Intensität',
          body: 'Eine Marke entsteht aus hunderten stimmigen Entscheidungen, nicht aus einem viralen Moment. Wir bauen Systeme, die Sie durchhalten können – und verfeinern sie konsequent.',
        },
        {
          title: 'Weniger Kunden, mehr Aufmerksamkeit',
          body: 'Die Kundenzahl bleibt absichtlich klein. Sie arbeiten direkt mit mir – nicht mit einem Account Manager, der Entscheidungen über drei Postfächer weiterreicht.',
        },
      ],
    },
    approach: {
      eyebrow: 'Was Sie erwarten können',
      title: 'Klar, nah und auf Niveau gehalten.',
      lede:
        'Die Arbeit mit einem kleinen Studio sollte sich anders anfühlen als die Arbeit mit einer Agentur. Das bedeutet in der Praxis Folgendes.',
      items: [
        'Eine dokumentierte Strategie, gegen die Sie wirklich briefen können',
        'Art Direction auf redaktionellem Niveau',
        'Klares Reporting mit Einordnung statt rohen Dashboards',
        'Direkten Zugang zu Romilda über das gesamte Projekt',
        'Ehrliche Empfehlungen – auch wenn weniger das Richtige ist',
      ],
      cta: 'Mit einer Beratung starten',
    },
    finalCta: {
      eyebrow: 'Sprechen wir',
      title: 'Wenn das nach Ihrer Art zu arbeiten klingt – beginnen wir.',
      body:
        'Buchen Sie eine Beratung und bringen Sie Ihre aktuelle Herausforderung mit. Sie verlassen das Gespräch mit einer klareren Richtung – ganz gleich, ob wir zusammenarbeiten oder nicht.',
    },
  },

  contactPage: {
    hero: {
      eyebrow: 'Kontakt',
      titleLines: ['Bauen wir etwas,', 'das Aufmerksamkeit verdient.'],
      lede:
        'Erzählen Sie uns kurz von Ihrer Marke und davon, wo es aktuell feststeckt. Sie verlassen die Beratung mit einer klareren Richtung – ganz gleich, ob wir am Ende zusammenarbeiten.',
      emailLabel: 'E-Mail',
      whatsappLabel: 'WhatsApp',
      responseLabel: 'Antwortzeit',
      responseValue: 'Innerhalb von 2 Werktagen',
    },
    form: {
      eyebrow: 'Beratungsanfrage',
      title: 'Erzählen Sie uns von Ihrer Marke.',
      lede:
        'Ein paar kurze Fragen. Je konkreter Sie sind, desto wertvoller wird das erste Gespräch.',
      nameLabel: 'Ihr Name *',
      namePlaceholder: 'Elena Rossi',
      brandLabel: 'Unternehmen / Markenname',
      brandPlaceholder: 'Casa Rossi',
      emailLabel: 'E-Mail *',
      emailPlaceholder: 'sie@ihremarke.de',
      serviceLabel: 'Gewünschte Leistung',
      servicePlaceholder: 'Leistung auswählen',
      budgetLabel: 'Budgetrahmen',
      budgetPlaceholder: 'Budget auswählen',
      timelineLabel: 'Zeitrahmen',
      timelinePlaceholder: 'Zeitrahmen auswählen',
      projectHint:
        'Websites, Apps und Automatisierungen entstehen gemeinsam mit unserem Technologie-Partner CloudService.hr. Budget und Zeitrahmen helfen bei einer realistischen ersten Einschätzung.',
      challengeLabel: 'Ihre größte aktuelle Herausforderung *',
      challengePlaceholder:
        'Zum Beispiel: Unser Instagram wirkt inkonsistent und wir bekommen kaum Anfragen darüber.',
      privacy: 'Ihre Angaben werden ausschließlich zur Beantwortung dieser Anfrage genutzt.',
      submit: 'Anfrage senden',
      errors: {
        name: 'Bitte nennen Sie uns Ihren Namen.',
        email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
        challenge:
          'Ein oder zwei Sätze zu Ihrer Herausforderung helfen uns bei der Vorbereitung.',
        incomplete: 'Bitte füllen Sie die markierten Felder aus.',
        failed:
          'Das konnte gerade nicht gesendet werden. Schreiben Sie uns gerne direkt per E-Mail.',
      },
      toastSuccess: 'Anfrage erhalten — Romilda meldet sich bei Ihnen.',
    },
    success: {
      title: 'Vielen Dank, {name}.',
      body: 'Ihre Anfrage liegt bei Romilda. Sie liest jede Nachricht persönlich und antwortet innerhalb von zwei Werktagen an {email}.',
      whileYouWait: 'Während Sie warten',
      continueWhatsapp: 'Auf WhatsApp weiterschreiben',
      sendAnother: 'Weitere Anfrage senden',
    },
    faq: [
      {
        q: 'Was passiert, nachdem ich das gesendet habe?',
        a: 'Romilda liest jede Anfrage persönlich und antwortet innerhalb von zwei Werktagen mit den nächsten Schritten oder einem Terminvorschlag.',
      },
      {
        q: 'Was deckt die Beratung ab?',
        a: 'Ihre Positionierung, Ihre Zielgruppe, was Wachstum bisher gebremst hat, und eine ehrliche Einschätzung, welche Leistung zuerst den größten Unterschied macht.',
      },
      {
        q: 'Nennen Sie Preise vor dem Gespräch?',
        a: 'Der Umfang wird auf Ihre Marke zugeschnitten. Deshalb sprechen wir über Preise in der Beratung, sobald klar ist, was die Arbeit wirklich erfordert.',
      },
    ],
    aiTeaser: {
      title: 'Erst eine sofortige Einschätzung?',
      body:
        'Fragen Sie Romilda AI – unten rechts auf Ihrem Bildschirm – nach einer ersten strategischen Richtung in unter einer Minute.',
    },
    bottom: {
      prefix: 'Lieber erst umsehen?',
      servicesLink: 'Leistungen ansehen',
      aboutLink: 'die Geschichte lesen',
    },
  },

  notFound: {
    title: 'Diese Seite ist weitergezogen.',
    body:
      'Die gesuchte Seite gibt es hier nicht. Bringen wir Sie zurück zu etwas Nützlichem.',
    home: 'Zurück zur Startseite',
  },

  ctaBlock: {
    eyebrow: 'Beginnen wir',
    title: 'Bereit, Ihre Marke auf ein neues Niveau zu bringen?',
    body:
      'Buchen Sie eine Beratung, und wir entwickeln eine Strategie, die zu Ihrer Vision passt – Ihre Zielgruppe, Ihre Ästhetik, Ihr Anspruch.',
  },

  widget: {
    launcherTitle: 'Romilda AI',
    launcherSubtitle: 'Sofort-Strategie',
    launcherAria: 'Romilda AI öffnen — Strategie-Impulse in Sekunden',
    panelAria: 'Romilda AI',
    welcomeTitle: 'Willkommen bei Romilda AI.',
    welcomeBody:
      'Erzählen Sie mir kurz von Ihrer Marke, und ich helfe Ihnen, Ihre nächste Wachstumschance zu erkennen.',
    startHere: 'Oder hier starten',
    thinking: 'Denkt nach',
    placeholder: 'Erzählen Sie von Ihrer Marke…',
    inputAria: 'Nachricht an Romilda AI',
    sendAria: 'Nachricht senden',
    disclaimer: 'Strategische Impulse, kein Ersatz für eine vollständige Beratung.',
    resetAria: 'Neues Gespräch beginnen',
    closeAria: 'Romilda AI schließen',
    emailInstead: 'Stattdessen E-Mail schreiben',
    unavailable:
      'Romilda AI ist gerade nicht erreichbar. Bitte versuchen Sie es erneut oder schreiben Sie an {email}.',
    quickActions: [
      {
        id: 'audit',

        label: 'Strategie prüfen',
        prompt:
          'Ich möchte eine Einschätzung meiner aktuellen Marketingstrategie. Wo sollten wir beginnen?',
      },
      {
        id: 'ideas',

        label: 'Content-Ideen',
        prompt: 'Ich brauche frische Content-Ideen für meine Marke.',
      },
      {
        id: 'website',

        label: 'Website & Automation',
        prompt:
          'Ich brauche eine neue Website oder möchte Abläufe mit KI automatisieren. Was ist möglich?',
      },
      {
        id: 'instagram',

        label: 'Instagram verbessern',
        prompt: 'Wie kann ich meinen Instagram-Auftritt verbessern?',
      },
      {
        id: 'branding',

        label: 'Hilfe beim Branding',
        prompt: 'Ich brauche Hilfe bei meinem Branding und meiner visuellen Identität.',
      },
      {
        id: 'audience',

        label: 'Reichweite aufbauen',
        prompt: 'Ich möchte meine Zielgruppe vergrößern. Worauf sollte ich mich konzentrieren?',
      },
      {
        id: 'services',

        label: 'Leistungen entdecken',
        prompt: 'Welche Ihrer Leistungen würde am besten zu mir passen?',
      },
    ],
    lead: {
      eyebrow: 'Weiter mit Romilda',
      title: 'Soll ich Ihre Angaben an Romilda weitergeben?',
      body: 'Sie meldet sich mit einem passenden nächsten Schritt – keine automatisierten Serien.',
      namePlaceholder: 'Ihr Name',
      emailPlaceholder: 'E-Mail-Adresse',
      focusPlaceholder: 'Worauf liegt Ihr Fokus?',
      dismissAria: 'Schließen',
      submit: 'An Romilda senden',
      error: 'Bitte geben Sie Ihren Namen und eine gültige E-Mail-Adresse an.',
      failed: 'Das konnte gerade nicht gespeichert werden. Bitte versuchen Sie es erneut.',
      toast: 'Vielen Dank — Romilda meldet sich persönlich bei Ihnen.',
      saved: 'Ihre Angaben liegen bei Romilda. Sie meldet sich persönlich bei Ihnen.',
    },
  },

  admin: {
    login: {
      eyebrow: 'Interner Bereich',
      title: 'Lead-Dashboard',
      body:
        'Geben Sie das Dashboard-Passwort ein, um erfasste Leads und AI-Gespräche zu sehen.',
      passwordLabel: 'Passwort',
      passwordPlaceholder: 'Dashboard-Passwort',
      submit: 'Anmelden',
      signingIn: 'Wird angemeldet…',
      wrong: 'Dieses Passwort ist nicht korrekt.',
      failed: 'Anmeldung nicht möglich. Bitte versuchen Sie es erneut.',
      empty: 'Bitte geben Sie das Passwort ein.',
    },
    eyebrow: 'Intern',
    title: 'Erfasste Leads',
    subtitle:
      'Anfragen aus dem Beratungsformular und Angaben, die in Romilda AI geteilt wurden.',
    signOut: 'Abmelden',
    refresh: 'Aktualisieren',
    exportCsv: 'CSV exportieren',
    exporting: 'Export läuft…',
    exportFailed: 'Der CSV-Export ist fehlgeschlagen.',
    stats: {
      total: 'Leads gesamt',
      unread: 'Neu / ungelesen',
      form: 'Aus dem Formular',
      ai: 'Aus Romilda AI',
    },
    filters: {
      all: 'Alle',
      new: 'Neu',
      form: 'Kontaktformular',
      ai: 'Romilda AI',
    },
    searchPlaceholder: 'Name, E-Mail, Marke suchen…',
    searchAria: 'Leads durchsuchen',
    loadError: 'Leads konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
    empty: {
      title: 'Noch keine Leads',
      body:
        'Anfragen aus dem Beratungsformular und von Romilda AI erfasste Angaben erscheinen hier.',
    },
    emptyFiltered: {
      title: 'Kein Treffer für diesen Filter',
      body: 'Probieren Sie einen anderen Filter oder löschen Sie die Suche.',
    },
    lead: {
      unnamed: 'Namenlose Besucherin / Besucher',
      sourceAi: 'Romilda AI',
      sourceForm: 'Kontaktformular',
      interest: 'Interesse',
      challenge: 'Herausforderung',
      summary: 'KI-Zusammenfassung',
      platform: 'Plattform',
      budget: 'Budgetrahmen',
      timeline: 'Zeitrahmen',
      message: 'Nachricht',
      viewDetails: 'Details ansehen',
      newBadge: 'Neu',
    },
    detail: {
      title: 'Lead-Details',
      contact: 'Kontakt',
      noEmail: 'Keine E-Mail angegeben',
      conversation: 'Romilda-AI-Gespräch',
      conversationEmpty:
        'Dieser Lead kam über das Kontaktformular – es gibt kein AI-Gespräch.',
      conversationLoading: 'Gespräch wird geladen…',
      visitor: 'Besucher',
      assistant: 'Romilda AI',
      messagesCount: '{count} Nachrichten',
      close: 'Schließen',
      emailAction: 'Per E-Mail antworten',
      whatsappAction: 'WhatsApp öffnen',
      statusLabel: 'Status',
      copyEmail: 'E-Mail kopieren',
      copied: 'E-Mail kopiert',
    },
    status: {
      new: 'Neu',
      read: 'Gelesen',
      contacted: 'Kontaktiert',
      archived: 'Archiviert',
    },
    statusUpdated: 'Status aktualisiert',
    statusFailed: 'Der Status konnte nicht aktualisiert werden.',
  },

  seo: {
    '/': {
      title:
        'Romilda Marketing Hub | Premium Content-Strategie, Social-Media-Wachstum & Branding',
      description:
        'Romilda Marketing Hub ist eine Premium-Agentur für digitales Marketing – Content-Strategie, Social-Media-Management, visuelle Identität und Digitalstrategie. Über 500.000 Views und 160.000 erreichte Accounts pro Monat. Jetzt Beratung buchen.',
      keywords:
        'Digitalagentur, Content-Strategie, Social-Media-Management, visuelle Identität, Branding Agentur, Instagram Wachstum, Marketing Agentur Deutschland, Premium Marketing, Romilda Marketing Hub',
    },
    '/services': {
      title:
        'Leistungen | Social-Media-Management, Content-Strategie, Branding & Digitalstrategie',
      description:
        'Fünf Disziplinen, eine Marke auf Niveau: Social-Media-Management, Content-Strategie und Ästhetik, visuelle Identität und Branding, datenbasierte Digitalstrategie sowie individuelle Websites und KI-Automatisierung. Für wen jede Leistung gedacht ist, welche Ergebnisse zu erwarten sind und was enthalten ist.',
      keywords:
        'Social Media Management Agentur, Content Strategie Agentur, Corporate Design, Logo und Brand Guidelines, Digitalstrategie Marketing, Instagram Content Strategie, individuelle Website erstellen, KI Automatisierung, Prozessautomatisierung Agentur',
    },
    '/about': {
      title: 'Über Romilda | Gründerin, Strategin & redaktionelle Art Directorin',
      description:
        'Romilda kennenlernen – Gründerin von Romilda Marketing Hub. Strukturierte Marketingstrategie verbunden mit redaktioneller Art Direction auf Modeniveau, für Marken, die Geschmack und Ergebnisse gleichzeitig wollen.',
      keywords:
        'Romilda Bahollari, Marketing Strategin, redaktionelle Art Direction, Personal Branding Agentur, inhabergeführtes Marketing Studio',
    },
    '/contact': {
      title: 'Beratung buchen | Kontakt zu Romilda Marketing Hub',
      description:
        'Buchen Sie eine Beratung bei Romilda Marketing Hub. Erzählen Sie von Ihrer Marke und Ihrer größten aktuellen Herausforderung und erhalten Sie eine passgenaue strategische Richtung. Erreichbar per Formular, E-Mail oder WhatsApp.',
      keywords:
        'Marketing Beratung buchen, Marketing Agentur kontaktieren, Strategiegespräch Marketing, Social Media Manager beauftragen',
    },
    '/leads': {
      title: 'Leads | Romilda Marketing Hub',
      description: 'Interne Lead-Übersicht für Romilda Marketing Hub.',
      noindex: true,
    },
    '*': {
      title: 'Seite nicht gefunden | Romilda Marketing Hub',
      description:
        'Die gesuchte Seite existiert nicht. Kehren Sie zu Romilda Marketing Hub zurück, um die Leistungen zu entdecken oder eine Beratung zu buchen.',
      noindex: true,
    },
  },

  ldDescription:
    'Premium-Agentur für digitales Marketing mit maßgeschneiderten Marketinglösungen, Content-Strategie, Social-Media-Wachstum, visueller Identität und Markenentwicklung.',
};

export default de;
